import { Reveal } from "@/components/motion";
import { Eyebrow, CTA } from "@/components/kit";
import { PassportStamp } from "@/components/PassportStamp";
import { IMG } from "@/data/content";
import { Globe2, Sparkles } from "lucide-react";

// Teaser de la Temporada 2 (próximamente)
export const Season2Teaser = ({ alt = false }) => (
  <section className={`px-5 sm:px-8 lg:px-12 py-16 sm:py-20 ${alt ? "bg-mist" : "bg-cream"}`}>
    <div className="mx-auto max-w-7xl">
      <Reveal className="overflow-hidden rounded-[2.5rem] bg-ink text-cream shadow-[0_20px_40px_rgb(0,0,0,0.15)]">
        <div className="grid items-center gap-8 lg:grid-cols-2">
          <div className="p-9 sm:p-14">
            <Eyebrow color="#E8C547">Próximamente · Nueva temporada</Eyebrow>
            <h2 className="mt-5 font-display text-4xl sm:text-6xl font-extrabold leading-[0.95] tracking-tighter">
              Temporada 2 · <span className="text-coral">el viaje continúa</span>
            </h2>
            <p className="mt-6 max-w-md text-cream/70 leading-relaxed">
              Nuevos destinos, nuevos retos y la misma amistad de siempre. Anto y
              Bella preparan las maletas para dar otra vuelta al mundo.
            </p>
            <div className="mt-7 flex flex-wrap items-center gap-3">
              <span className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-2 font-mono text-xs uppercase tracking-widest text-mint">
                <Globe2 className="h-4 w-4" /> Nuevos destinos
              </span>
              <span className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-2 font-mono text-xs uppercase tracking-widest text-sky">
                <Sparkles className="h-4 w-4" /> En desarrollo
              </span>
            </div>
            <CTA to="/believers" variant="coral" className="mt-8" data-testid="season2-cta">
              Avísame del estreno
            </CTA>
          </div>
          <div className="relative">
            <img
              src={IMG.season2Promo}
              alt="Anto y Bella — Temporada 2"
              className="w-full object-cover"
              data-testid="season2-image"
            />
            <div className="absolute -left-4 top-6 sm:left-6">
              <PassportStamp code="T2" label="TEMP.2" color="#E8C547" rotate={-12} size={96} />
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
